export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9618.f959c305.jpg";